<template>
    <b-button
        class="part-button h-100 d-flex justify-content-between align-items-center p-3"
        :class="!active ? 'part-button--inactive' : ''"
        :variant="variant"
        :disabled="!active"
        @click="handleClick"
        block
    >
        <div class="text-left">
            <slot />
        </div>
        <div class="part-button__arrow-icon">
            <b-spinner
              label="Loading..."
              v-if="active && isLoading"
              class="align-middle">
            </b-spinner>
            <span v-if="active && !isLoading">
                <img
                    v-svg-inline
                    :class="`part-button__arrow--${variant}`"
                    src="@/assets/ui/part-nav-arrow.svg"
                    height="100%"
                    width="100%"
                />
            </span>
        </div>
    </b-button>
</template>
<script>
export default {
    name: 'partButton',
    props: {
        variant: {
            type: String,
            default: 'bq-green'
        },
        active: {
            type: Boolean,
            default: true,
        },
        isLoading: {
          type: Boolean,
          default: false
        },
        navigationInProgress: {
          type: Boolean,
          default: false
        }
    },
    methods: {
        handleClick() {
          // only trigger the click event in case the user hasn't already clicked it
          // and we already have an ongoing request to the backend, this will avoid
          // sending multiple requests on a slow internet connection, if the user
          // clicks the button multiple times.
          if (!this.navigationInProgress){
            this.$emit('click')
          }
        }
    }
}
</script>
<style lang="scss">
    .part-button__arrow-icon {
        height: 40px;
        width: 40px;
    }

    .part-button.disabled {
        background-color: $base_grey-4;
        color: $main-font-grey;
        border: none;
        cursor: default !important;
        &:hover {
            background-color: $base_grey-4;
            color: $main-font-grey;
        }
    }

    .part-button__arrow {
        &--bq-green {
            * {
                stroke: $bq-green;
            }
        }
        &--bq-burgundy {
            * {
                stroke: $bq-burgundy;
            }
        }
        &--bq-blue {
            * {
                stroke: $bq-blue;
            }
        }
        &--bq-turquoise {
            * {
                stroke: $bq-turquoise;
            }
        }
        &--bq-red {
            * {
                stroke: $bq-red;
            }
        }

        &--bq-orange {
            * {
                stroke: $bq-orange;
            }
        }
    }
</style>
